import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const PhotoFrame = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: ${({ theme }) =>
    theme.globalConstants.color.backgroundGray};
  aspect-ratio: 4 / 5;
`;

export const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
`;
